export default "__VITE_ASSET__DBLvDN3H__"